(function () {
  var pending = false;
  document.addEventListener('click', async function (event) {
    var trigger = event.target.closest('.js-open-consent');
    if (!trigger) return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    trigger.setAttribute('aria-busy', 'true');
    var status = document.getElementById('gurmeo-consent-status');
    if (!status) {
      status = document.createElement('p');
      status.id = 'gurmeo-consent-status';
      status.className = 'gurmeo-consent-error';
      status.setAttribute('role', 'status');
      trigger.parentElement.insertAdjacentElement('afterend', status);
    }
    status.textContent = '';
    try {
      // Native Shopify banner is injected by content_for_header. Wait briefly
      // for its async load; do not inject a second consent manager or set consent.
      for (var attempt = 0; attempt < 20; attempt++) {
        if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') break;
        await new Promise(function (resolve) { setTimeout(resolve, 100); });
      }
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('Banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      status.textContent = 'Die Cookie-Einstellungen konnten nicht geöffnet werden. Bitte laden Sie die Seite erneut und versuchen Sie es noch einmal.';
    } finally {
      pending = false;
      trigger.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === ' ' && event.target.matches('.js-open-consent[role="button"]')) {
      event.preventDefault();
      event.target.click();
    }
  });
})();
